<template>
  <div class="tab-bar" v-if="!hideTabBar">
    <transition name="fade-stack">
      <div v-if="!showAction && !isLocked" class="primary-bar">
        <RouterLink to="/" class="tab-item" :class="{'active' : routeMetaTab === 'home'}" @click.native="refreshHome">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 2.16832H15.7838V12.4675C14.155 9.40594 9.565 4.52475 6.76459 2L4.61138 3.77282C6.54658 7.47106 7.6396 10.1341 8.69402 13.1572C7.24026 11.7483 5.81028 10.4397 3.73778 8.84349L2 10.4196C3.47978 12.6904 4.32512 13.9955 4.89136 16.2644L3.33979 15.8149L2.66855 18.0869L5.8215 19L7.64049 17.8051L7.4996 17.0377C7.34436 16.1936 7.16488 15.4563 6.95759 14.7865L11.143 18.8541L13.0948 17.6047C12.4168 15.4087 11.8824 13.1138 11.0707 11.0436C13.0688 13.5489 15.132 17.1829 15.7502 18.6558H19V2.16832Z" />
          </svg>
          <span>Channels</span>
        </RouterLink>

        <RouterLink to="/topics" class="tab-item" :class="{'active' : routeMetaTab === 'explore'}" @click.native="tap('Headlines')">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5996 10.5C18.5996 6.02649 14.9735 2.40039 10.5 2.40039C6.02646 2.40039 2.40036 6.02649 2.40036 10.5C2.40036 14.9735 6.02646 18.5996 10.5 18.5996C14.9735 18.5996 18.5996 14.9735 18.5996 10.5ZM13.9697 6.20801C14.2032 6.13033 14.4607 6.19123 14.6347 6.36523C14.8087 6.53924 14.8696 6.7968 14.792 7.03027L12.9541 12.543C12.8975 12.7127 12.7741 12.8506 12.6142 12.9258L12.5429 12.9541L7.03024 14.792C6.79677 14.8697 6.53921 14.8088 6.3652 14.6348C6.1912 14.4608 6.1303 14.2032 6.20798 13.9697L8.04587 8.45703L8.07419 8.38574C8.14938 8.22588 8.28732 8.10246 8.457 8.0459L13.9697 6.20801ZM9.17575 9.17578L7.85251 13.1465L11.8232 11.8232L13.1465 7.85254L9.17575 9.17578ZM19.9004 10.5C19.9004 15.6915 15.6914 19.9004 10.5 19.9004C5.30849 19.9004 1.09958 15.6915 1.09958 10.5C1.09958 5.30852 5.30849 1.09961 10.5 1.09961C15.6914 1.09961 19.9004 5.30852 19.9004 10.5Z" />
          </svg>
          <span>Headlines</span>
        </RouterLink>

        <RouterLink :to="isNourish2 ? '/dashboard' : '/'" class="tab-item user-track" @click.native="tap('Dashboard')">
          <UserTrack :size="75" :xxfocus="dialFocus" />
        </RouterLink>

        <RouterLink to="/search" class="tab-item" :class="{'active' : routeMetaTab === 'search'}" @click.native="tap('Search')">
          <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 9.09961C16 5.50976 13.0899 2.59961 9.5 2.59961C5.91015 2.59961 3 5.50976 3 9.09961C3 12.6895 5.91015 15.5996 9.5 15.5996C13.0899 15.5996 16 12.6895 16 9.09961ZM17 9.09961C17 10.9907 16.2985 12.7169 15.1436 14.0361L19.9219 18.8145L19.9863 18.8926C20.1145 19.0867 20.0927 19.3506 19.9219 19.5215C19.751 19.6923 19.487 19.7141 19.293 19.5859L19.2148 19.5215L14.4365 14.7432C13.1173 15.8981 11.3911 16.5996 9.5 16.5996C5.35786 16.5996 2 13.2417 2 9.09961C2 4.95747 5.35786 1.59961 9.5 1.59961C13.6421 1.59961 17 4.95747 17 9.09961Z" />
          </svg>
          <span>Ask</span>
        </RouterLink>

        <div @click="routeProfile()" class="tab-item" :class="{'active' : routeMetaTab === 'profile'}">
          <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7246 6.125C14.7246 4.06811 13.0569 2.40039 11 2.40039C8.94234 2.40039 7.27541 4.06803 7.27541 6.125C7.27541 8.11856 8.83987 9.74514 10.8086 9.84473L11 9.84961L11.1914 9.84473C13.1595 9.7451 14.7246 8.11846 14.7246 6.125ZM16.0254 6.125C16.0254 7.8536 15.1518 9.3771 13.8233 10.2812C17.635 11.4803 20.4004 15.0429 20.4004 19.25C20.4004 19.609 20.109 19.9004 19.75 19.9004C19.391 19.9004 19.0996 19.609 19.0996 19.25C19.0996 14.7772 15.4728 11.1504 11 11.1504C6.52642 11.1504 2.90041 14.7772 2.90041 19.25C2.90041 19.609 2.60901 19.9004 2.25002 19.9004C1.89104 19.9004 1.59963 19.609 1.59963 19.25C1.59963 15.0431 4.36415 11.4805 8.1758 10.2812C6.84753 9.37705 5.97463 7.85339 5.97463 6.125C5.97463 3.35022 8.2242 1.09961 11 1.09961C13.7749 1.09961 16.0254 3.35014 16.0254 6.125Z" />
          </svg>
          <span>Profile</span>
        </div>
      </div>
    </transition>

    <transition name="slide-animate">
      <div v-if="showAction" class="action-bar">
        <!-- Share Button -->
        <div class="tab-wrapper">
          <button v-if="showShare" class="tab-item active" @click="share()">
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.1857 6.20633C12.7052 6.20633 13.1231 5.79123 13.1231 5.27525V2.73806L17.8646 7.44777L13.1231 12.1575V9.62029C13.1231 9.10432 12.7052 8.68921 12.1857 8.68921H7.4989C4.91334 8.68921 2.73397 10.4233 2.07782 12.7821C1.94893 12.301 1.87473 11.7656 1.87473 11.1721C1.87473 8.42928 4.11268 6.20633 6.87399 6.20633H12.1857ZM11.2484 10.5514V13.655C11.2484 14.1554 11.553 14.6093 12.0217 14.8033C12.4904 14.9973 13.0254 14.8886 13.3848 14.5356L19.6338 8.32842C20.1221 7.84348 20.1221 7.05594 19.6338 6.571L13.3848 0.363811C13.0254 0.00689694 12.4904 -0.0978495 12.0217 0.0961253C11.553 0.2901 11.2484 0.740122 11.2484 1.24058V4.34417H6.87399C3.07767 4.34417 0 7.40122 0 11.1721C0 14.1981 1.50759 16.068 2.6832 17.0728C2.84333 17.2086 2.99956 17.3288 3.14016 17.4336C3.26515 17.5267 3.38232 17.6043 3.48777 17.6741C3.66353 17.7905 3.81194 17.872 3.90958 17.9263C4.00723 17.9806 4.11658 18 4.22594 18C4.65166 18 4.99536 17.6547 4.99536 17.2357C4.99536 16.9719 4.85476 16.7236 4.67119 16.5336C4.65166 16.5142 4.63604 16.4986 4.61651 16.4792C4.52277 16.39 4.41732 16.2814 4.31577 16.1456C4.24938 16.0564 4.18298 15.9516 4.12049 15.8391C3.91349 15.4628 3.74945 14.9507 3.74945 14.2796C3.74945 12.2234 5.42889 10.5552 7.4989 10.5552H11.2484V10.5514Z" fill="white"/>
            </svg>
            <span>Share</span>
          </button>
        </div>

        <!-- 5-dot tracker -->
        <div class="tab-wrapper tab-track">
          <transition name="slide-animate">
            <div v-if="isStack && hasDots && !isStory" class="tab-item tracker">
              <div v-for="(stack, idx) in action.structure" :key="idx" class="dot" :class="{'hidden' : stack.dot === false, 'complete' : idx < action.index || idx <= action.stats.read, 'focus' : idx === action.index }"></div>
            </div>
          </transition>

          <button v-if="isStory && !isNourish2" class="upgrade-item" @click="upgrade('onesub')">
            <span>Upgrade to Nourish 2</span>
            <base-svg svg="meta-celebrate" height="1.2rem" />
          </button>
        </div>

        <!-- Action Button: Done, Next Etc.. -->
        <div class="tab-wrapper">

          <!-- "HideNext" is universal -->
          <template v-if="!hideNext">

            <!-- Show on "isEnd" -->
            <button v-if="isEnd" class="tab-item" :class="{'active' : isEnd}" @click="next()">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7741 6.21617C18.0753 6.53643 18.0753 7.01681 17.7741 7.30504L8.93977 15.7598C8.60513 16.0801 8.10318 16.0801 7.80201 15.7598L3.25098 11.4043C2.91634 11.1161 2.91634 10.6357 3.25098 10.3475C3.55215 10.0272 4.0541 10.0272 4.35527 10.3475L8.33742 14.1585L16.6364 6.21617C16.9375 5.92794 17.4395 5.92794 17.7407 6.21617H17.7741Z" />
              </svg>
              <span>Done</span>
            </button>

            <!-- or is showNext -->
            <button v-else-if="showNext" :disabled="!action.enableNext" class="tab-item" :class="{'active': action.enableNext, 'inactive': !action.enableNext}" @click="next()">
              <svg class="next-arrow" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.6426 11.3799L13.6426 9.87109L5.05469 3L3.48438 3.75391L3.48438 17.4971L5.05469 18.252L13.6426 11.3799ZM17.4414 3.64648H15.5088L15.5088 17.6035H17.4414V3.64648ZM5.41699 5.76562L11.4932 10.626L5.41699 15.4863L5.41699 5.76562Z" />
              </svg>
              <transition-group name="swap">
                <span key="scroll" v-if="!action.enableNext">{{ action.disableLabel || '•' }}</span>
                <span key="next" v-else>Next</span>
              </transition-group>
            </button>

          </template>
        </div>
      </div>
    </transition>

    <transition name="slide-up">
      <div v-if="continueReading.visible" class="continue-reading" @click="routeContinue()">
        <div class="track">
          <span class="message">Continue: <span class="stack">{{ continueReading.title }}</span></span>
          <Tracker class="tracker" :stats="continueReading.stats"/>
        </div>

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM9.85355 18.3536L15.8536 12.3536C16.0488 12.1583 16.0488 11.8417 15.8536 11.6464L9.85355 5.64645C9.65829 5.45118 9.34171 5.45118 9.14645 5.64645C8.95118 5.84171 8.95118 6.15829 9.14645 6.35355L14.7929 12L9.14645 17.6464C8.95118 17.8417 8.95118 18.1583 9.14645 18.3536C9.34171 18.5488 9.65829 18.5488 9.85355 18.3536Z" fill="#0B0D0E"/>
        </svg>
      </div>
    </transition>
  </div>
</template>

<script>
  import API from 'app/axios';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import Tracker from '@/components/v5/stacks/Tracker.vue';

  export default {
    data() {
      return {
        hideNext: false,
        oCurrentFaux: {},
        action: {
          structure: [
            { end: false }
          ],
          index: 0,
          stats: {
            read: 0,
          },
          // progress: {
          //   focus: 0,
          //   total: 0,
          // },
          // isEnd: false,
          enableNext: false,
        },
        continueReading: {
          visible: false,
        },
      }
    },

    components: {
      UserTrack,
      Tracker,
    },

    mounted () {
      // console.log('\x1b[31mTabBar:: MOUNTED');

      this.EventBus.$on('tab:update', (payload) =>{
        // console.log('\x1b[31mTabBar:: Update: ', payload);
        this.action = payload;
      })

      this.EventBus.$on('tab:hide-next', (hide) => {
        this.hideNext = hide || false;
      })

      this.EventBus.$on('tab:continue', (payload) => {
        this.continueReading = payload;
      });

      this.EventBus.$on('stack:scroll', (e) => {
        if (e.position > 75) {
          this.action.enableNext = true;
        }
      });

      // console.log(`\x1b[31mTabBar:: Listening...`);
      this.EventBus.$on('layer:top', (oLayer) => {
        // console.log(`\x1b[31mTabBar:: Top changed: `, oLayer.component, oLayer.opts);
        if (oLayer.component == 'swipe') {
          // this is the bottom of a faux-stack (so clear it)
          this.oCurrentFaux = {};
          return;
        }
        this.oCurrentFaux = oLayer;

        // HACK! .. this should be in a watcher
        // console.log(`\x1b[31mTabBar:: Top changed: `, oLayer.component, this.isStory, (this.oCurrentFaux?.component == 'story'), this.oCurrentFaux?.component);
        if (['story', 'legacy-article'].includes(this.oCurrentFaux?.component)) {
          this.hideNext = false;
          this.action.enableNext = true;
        } else {
          this.hideNext = false;
        }
      });

      // Mounted in story view, set correct action
      if (this.isStory) {
        this.hideNext = false;
        this.action.enableNext = true;
      }
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      hasApp() {
        return this.$store.getters.hasApp;
      },

      isLoggedIn() {
				return this.$store.getters.isLoggedIn;
      },

      isNourish2() {
        return this.$store.getters.isNourish2;
      },

      hideTabBar() {
        // if (this.$mq != 'sm') { // not mobile?
        //   console.log('\x1b[31mTabBar:: mq:sm');
        //   return true;
        // }

        if (this.$route?.path === '/n/newsle' || this.$route?.path.includes('/n/five-to-thrive')) { // Hide on specific routes
          return true;
        }
        if (this.$route?.meta?.display?.tab_bar === 'hide') { // router says no
          // console.log('\x1b[31mTabBar:: router');
          return true;
        }
        if (this.$store.getters.hasMini) { // we're in "mini" mode?
          // console.log('\x1b[31mTabBar:: hasMini');
          return true;
        }
        if (this.$layoutEngine.isStackPreviewPane) { // new: stack-preview pane
          // console.log('\x1b[31mTabBar:: isStackPreviewPane');
          return true;
        }
        // show!
        // console.log('\x1b[31mTabBar:: no! Show...');
        return false;
      },

      routeMetaTab() {
        return this.$route.meta?.tab || 'home';
      },

      routeParams() {
        return this.$route.params;
      },

      isStack() {
        return this.$route.path.startsWith('/n/') && !this.isLocked;
      },

      isStory() {
        return (['story', 'legacy-article'].includes(this.oCurrentFaux?.component)) || this.$route.path.startsWith('/story/');
      },

      isLocked() {
        return this.$route.path.startsWith('/n/pro') || this.$route.path.startsWith('/n/unlock');
      },

      isProfile() {
        return this.$route.path.startsWith('/n/profile');
      },

      showAction() {
        if (this.isStack || this.isStory || this.isProfile) {
          return true;
        }
        return false;
      },

      showShare() {
        if (
          this.$route.path.includes('welcome') ||
          this.$route.path.includes('profile') ||
          this.$route.path.includes('coaching') ||
          this.$route.path.includes('notifications') ||
          this.$route.path.includes('start')
        ) {
          return false;
        }
        return true;
      },
 
      hasDots() {
        return this.action?.structure?.length > 0
      },

      isEnd() {
        if (this.isStory) {
          return true;
        }

        if (this.action?.structure?.[this.action?.index]?.end) {
          return true;
        }

        if (this.action?.structure?.length <= 1) {
          return true;
        }

        return false;
      },

      showNext() {
        if (this.$route.path.includes('auth') || this.$route.path.includes('download-app')) {
          return false;
        }
        
        return true;
      },

      dialFocus() {
        return this.$userEngine.dialUnlocked;
        // return this.$userEngine.dialFocus;
      },
    },

    methods: {
      upgrade(sFallbackInvite = null) {
        if (!this.$userEngine.getOnboardMemo()?.invited_by) {
          this.$userEngine.setOnboardMemo({
            invited_by: 'onesub',
          });
        }
        let sInvite = this.$userEngine.getOnboardMemo()?.invited_by || sFallbackInvite;
        if (sInvite) {
          this.EventBus.$emit('layer:new', {
            'component': 'Invite',
            'opts': {},
          });
        } else {
          this.EventBus.$emit('modal:nourish-appflow');
        }
      },

      next() {
        this.EventBus.$emit("device:haptic", 'light');

        // continually reload the homepage (not massively wise but..)
        API.getStackShelves();

        // console.log('\x1b[31mTabBar:: NEXT: ', this.oCurrentFaux);
        if (['story', 'legacy-article'].includes(this.oCurrentFaux?.component)) {
          // console.log('\x1b[31mTabBar:: Top Done: ', this.oCurrentFaux);
          if (this.oCurrentFaux?.component == 'story') {
            this.$userEngine.markRead(this.oCurrentFaux?.opts?.slug, {state: 'read'});
          } else {
            this.$userEngine.markArticleRead(this.oCurrentFaux?.opts?.slug, {state: 'read'});
          }
          this.EventBus.$emit('layer:close');
          return;
        }

        if (this.isStory) {
          console.log('History Count: ', this.$historyCount())
          if (this.$historyCount() > 0) {
            console.log('History: Route back')
            this.$router.back();
          } else {
            console.log('History: Route home')
            this.$router.push('/');
          }
          return;
        }

        this.EventBus.$emit('swiper:next');
      },

      share() {
        const slide = this.action?.structure[this.action?.index];

        console.log('ROUTE', this.$route.path)

        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'url',
              link: `https://nourished.news${this.$route.path}`,
            }
          });
          return;
        } else {
          this.EventBus.$emit('layer:new', {
            component: 'message',
            hasTabBar: true,
            opts: {
              heading: `Spread the love`,
              message: `Share with someone and help them discover a better news.`,
              share: {
                url: `https://nourished.news${this.$route.path}`,
                message: slide?.meta?.promo || 'Check out this story on Nourished',
              }
            },
          });
        }
      },

      routeContinue() {
        this.$router.push(this.continueReading.route);
        this.continueReading = {
          visible: false
        }
      },

      routeProfile() {
        if (this.isLoggedIn) {
          this.EventBus.$emit('api:build-check');
          this.EventBus.$emit('xp:sparkle');
          if (this.isNourish2) {
            this.tap('Profile');
            this.$router.push(`/~${this.getAccount.screen_name}/invite`)
          } else {
            this.$router.push('/account')
          }
        } else {
          this.$router.push('/n/welcome?n=sign-in');
        }
      },

      refreshHome() {
        this.tap('Home', 'medium');
        API.getStackShelves();
        window.scrollTo({top: 0, behavior: 'smooth'});
      },

      tap(sTab, sNote = 'light') {
        // console.log(`Tap: ${sTab}`);

        // acknowledge ..
        this.EventBus.$emit("device:haptic", sNote);

        // .. record
        this.EventBus.$emit('track:event', {
          // once: false,
          event: 'tap-tab',
          props: {
            tab: sTab,
          },
          detail: {
            detail_char: sTab,
          },
        });
      }
    },

    watch: {
      showAction(willShow) {
        if (!willShow) {
          // Reset action progress so tab will animate correctly between stack changes
          this.action.progress = {
            structure: [],
            index: 0,
          }
        }
      },

      $route() {
        if (this.isStory) {
          this.action.enableNext = true;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .tab-bar {
    position: fixed;
    z-index: 9999;
    left: 0;
    right: 0;
    bottom: 0;

    .primary-bar,
    .action-bar {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      max-width: 900px;
      margin: auto auto 0 auto;
    }

    .primary-bar {
      z-index: 9999;
      padding: 0.3rem 0.5rem calc(env(safe-area-inset-bottom) + 0.3rem) 0.5rem;
      background: $neutral-600;

      .darkmode & {
        background: $neutral-100;
      }

      .desktop & {
        display: none;

        .darkmode & {
          background: $neutral-200;
        }
      }
    }

    .action-bar {
      z-index: 99991;
      padding: 0.45rem 0.5rem calc(env(safe-area-inset-bottom) + 0.45rem) 0.5rem;
      backdrop-filter: blur(4px);
      background: rgba($neutral-600, 0.8);
      border-top: 1px solid rgba($neutral-400, 0.2);

      .darkmode & {
        background: rgba($neutral-100, 0.8);
      }

      .desktop & {
        padding: 1rem 0.5rem calc(env(safe-area-inset-bottom) + 1rem) 0.5rem;

        .darkmode & {
          background: rgba($neutral-200, 0.9);
        }
      }

      .tab-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tab-track {
        grid-column: 2 / span 3;
        align-self: center;
        justify-content: center;
      }

      .upgrade-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        svg {
          fill: $neutral-100;
        }
      }

      .tab-item {
        padding: 0.5rem 0;

        &:disabled {
          opacity: 0.4;
        }

        &.tracker {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 50%;
          margin: 0 2.4rem;

          .dot {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 500px;
            background: rgba($neutral-100, 0.2);

            .darkmode & {
              background: rgba($neutral-600, 0.2);
            }

            &.hidden {
              display: none;
            }

            &.focus {
              background: $neutral-100;

              .darkmode & {
                background: $neutral-600;
              }
            }

            &.complete {
              background: $green-tone-3;
            }

            &:not(:last-child) {
              margin-right: 0.3rem;
            }
          }
        }
      }
    }

    .tab-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;
      justify-self: center;
      font-size: 0.75rem;
      font-weight: normal;
      background: none;
      color: $neutral-400;
      width: 25%;

      .desktop & {
        flex-direction: row-reverse;
        gap: 0.75rem;
        font-size: 1rem;
        width: unset;
      }

      &.user-track {
        width: 100%;
        margin-top: -1rem;
        border-radius: 500px;
        background: $neutral-600;

        .darkmode & {
          background: $neutral-100;
        }
      }

      svg {
        margin-bottom: 0.2rem;

        .desktop & {
          margin-bottom: 0;
        }

        path {
          fill: $neutral-400;
        }
      }

      &.active {
        color: $neutral-100;

        svg path {
          fill: $neutral-100;
        }

        .darkmode & {
          color: $neutral-600;

          svg path {
            fill: $neutral-600;
          }
        }
      }
    }
  }

  .continue-reading {
    position: absolute;
    top: -8.2rem;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 500px;
    padding: 1rem 1rem 1.2rem 1rem;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: $yellow-tone-3;
    color: $neutral-100;
    z-index: 5;

    .track {
      display: flex;
      flex-direction: column;

      .message {
        font-weight: bold;

        .stack {
          font-weight: normal;
        }
      }

      .track-wrap {
        margin-top: 0.3rem;
      }
    }
  }

  .fade-stack-enter-active,
  .fade-stack-leave-active {
    transition: opacity 0.2s ease-in-out;
  }

  .fade-stack-enter,
  .fade-stack-leave-to {
    opacity: 0;
  }

  .slide-animate-enter-active,
  .slide-animate-leave-active {
    transition: transform 0.25s ease-in-out;
  }

  .slide-animate-enter,
  .slide-animate-leave-to {
    transform: translateY(100%);
  }

  .slide-animate-leave-from,
  .slide-animate-enter-to {
    transform: translateY(0%);
  }




  /**
   *  Next Buttons
   */
  .inactive .next-arrow {
    transform: rotate(90deg);
    transition: all .3s;
  }
  .active .next-arrow {
    transform: rotate(0deg);
    transition: all .3s;
  }

  .swap-enter-active, .swap-leave-active {
    transition: opacity .5s;
  }
  .swap-enter, .swap-leave-to /* .swap-leave-active below version 2.1.8 */ {
    opacity: 0;
    position: absolute;
  }
</style>